"use strict";
import { useAppSelector } from "state/hooks";
export function useAllLists() {
  return useAppSelector((state) => state.lists.byUrl);
}
